export default "__VITE_ASSET__b1eceaec__"